import React, {ReactNode} from 'react';
import classNames from 'classnames';
import './TabPanel.styl';
import isNumber from 'lodash/isNumber';

interface Props {
  title?: string;
  onChange?: (idx: number) => void;
  defaultSelectedIdx: number;
  buttonLabel?: string;
  buttons?: any[];
  tabs: string[];
  panels: ReactNode[];
  className?: string;
  wrapperClassName?: string;
  titleClassName?: string;
}

interface State {
  selectedPanel: number | undefined;
}

export default class TabPanel extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {selectedPanel: props.defaultSelectedIdx};
    this.getRenderIdx = this.getRenderIdx.bind(this);
  }

  handleClick(i) {
    if (this.props.onChange) {
      this.props.onChange(i);
    }
    this.setState({selectedPanel: i});
  }

  getRenderIdx() {
    const {defaultSelectedIdx} = this.props;
    const {selectedPanel} = this.state;

    if (isNumber(selectedPanel) && !isNaN(selectedPanel)) return selectedPanel;

    if (isNumber(defaultSelectedIdx) && !isNaN(defaultSelectedIdx)) return defaultSelectedIdx;

    return 0;
  }

  render() {
    const {title, buttonLabel, buttons, tabs, panels, wrapperClassName, className, titleClassName} =
      this.props;

    const renderIdx = this.getRenderIdx();
    const panel = panels[renderIdx];

    return (
      <div className={classNames(className, 'tab-panel-outer')}>
        <div className={titleClassName}>{title}</div>
        {panels.length > 1 && (
          <div className={'panel-switcher-row'}>
            {buttonLabel && <span className={'button-label'}>{buttonLabel}</span>}
            {buttons &&
              buttons.map((Icon, i) => (
                <div key={i} className={'panel-button'} onClick={() => this.handleClick(i)}>
                  <Icon selected={renderIdx === i} />
                </div>
              ))}
            {tabs &&
              tabs.map((tab, i) => (
                <div
                  key={i}
                  className={classNames('panel-tab', renderIdx === i && 'selected')}
                  onClick={() => this.handleClick(i)}>
                  <span>{tab}</span>
                </div>
              ))}
          </div>
        )}
        <div className={wrapperClassName ? wrapperClassName : 'panel-wrapper'}>{panel}</div>
      </div>
    );
  }
}
